import '@/components/inject';
import { Locales, microRewriteBeforeEach } from '@/components/mambas';
import lodash from 'lodash';
import { $AppConfig } from './global';
import './microApp';
import { Store } from './store';
import './vueUse/directive';
export * from './extension';
export * from './global';
export * from './mamba';
export * from './pages';
export * from './prototype';
export default async (ctx) => {
    // 解决 微应用模式下 keepAlive 路由会改变
    microRewriteBeforeEach(ctx);
    lodash.set(ctx, '$Store', Store);
    lodash.set(ctx, 'AppConfig', $AppConfig);
    Locales.inject(ctx);
    ctx.app.head = () => {
        return {
            titleTemplate: (title) => {
                if ($AppConfig.ChildrenPage)
                    return;
                return title;
            },
        };
    };
    await Store.System.Auth.HydrateAsync;
    // ParseToken(ctx);
    // 用户校验
    Store.System.onVerify();
};
export function ParseToken(context) {
    let query = lodash.cloneDeep(context.query);
    if (!Store.System.AccessToken || lodash.get(query, 'change')) {
        const token = lodash.find([getAdminToken()], lodash.identity); // lodash.defaultTo(getUserToken(), getAccountToken());
        if (token) {
            query = lodash.assign(query, { token });
            context.$Store.System.resetToken(token);
        }
    }
    Store.System.onParseQueryToken(query);
}
function getAdminToken() {
    try {
        return sessionStorage.getItem('token');
    }
    catch (error) { }
}
